import Dialog from '@pelckmans/elementis/components/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import ModalContext from '../../../contexts/ModalContext';
import { buildGroupProps } from '../../../utils/elementisUtils';
import Button from '@pelckmans/elementis/components/button';

const BASE_TRANSLATION_KEY = 'PAGES.PROFILE.MY_DETAILS.LINKED_ACCOUNTS.SMARTSCHOOL_DECOUPLING_MODAL';

interface Props {
  id: string;
  onConfirm: () => Promise<void>;
}

function SmartschoolDecouplingModal({ id, onConfirm }: Props) {
  const { t } = useTranslation();

  const { closeModal } = useContext(ModalContext);

  function handleClose() {
    closeModal(id);
  }

  function handleConfirm() {
    onConfirm();
  }

  return (
    <Dialog id={id} aria-label={t(`${BASE_TRANSLATION_KEY}.A11Y_LABEL`)} modal onClose={handleClose} size="sm">
      <Dialog.Header
        title={t(`${BASE_TRANSLATION_KEY}.HEADER.TITLE`)}
        onClose={handleClose}
        aria-label={t('ACTIONS.CLOSE')}
        danger
      />
      <Dialog.Body>{t(`${BASE_TRANSLATION_KEY}.BODY.TEXT`)}</Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsRight={buildGroupProps(
          <>
            <Button key="cancel" prominence="neutral" onClick={handleClose}>
              {t(`${BASE_TRANSLATION_KEY}.FOOTER.ACTIONS.CANCEL`)}
            </Button>
            <Button key="confirm" prominence="danger" onClick={handleConfirm}>
              {t(`${BASE_TRANSLATION_KEY}.FOOTER.ACTIONS.CONFIRM`)}
            </Button>
          </>,
        )}
      />
    </Dialog>
  );
}

export default SmartschoolDecouplingModal;
